// src/pages/SafetyProcedures.js
import React from 'react';

function SafetyProcedures() {
  return (
    <div>
      <h2>Safety Procedures</h2>
      <p>This page will host the safety procedures manuals for the company.</p>
    </div>
  );
}

export default SafetyProcedures;
